import React from "react";
import { Box, Typography, IconButton, List, ListItem, ListItemText, Avatar, Tooltip } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const NotificationPanel = ({ onClose, notificationForPanel = [] }) => {
  return (
    <Box
      className="notification-panel-container"
      sx={{
        position: "fixed",
        top: "80px",
        right: "10px",
        width: { xs: "90%", sm: "380px" },
        maxHeight: "calc(100vh - 120px)",
        bgcolor: "#fdfdfd",
        boxShadow: "-3px 0 15px rgba(0,0,0,0.2)",
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
      }}>

      {/* Header */}
      <Box
        className="notification-panel-header"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "linear-gradient(90deg, #3D0808 0%, #6b1b1b 100%)",
          color: "white",
          px: 2,
          py: 1,
        }}>

        <Typography
          className="notification-panel-title"
          variant="h6"
          sx={{ fontWeight: 600 }}>
          Notifications
        </Typography>

        <Tooltip title="Close">
          <IconButton
            className="notification-panel-close-btn"
            size="small"
            onClick={onClose}
            sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Notification List */}
      <Box
        className="notification-panel-body"
        sx={{ flex: 1, overflowY: "auto", p: 2 }}>
        {notificationForPanel.length > 0 ? (
          <List className="notification-list" disablePadding>
            {[...notificationForPanel]
              .sort((a, b) => b.NotificationId - a.NotificationId)
              .map((notification) => (
                <ListItem
                  key={notification.NotificationId}
                  className="notification-list-item"
                  alignItems="flex-start"
                  sx={{
                    borderRadius: "10px",
                    mb: 1.5,
                    bgcolor: "white",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
                  }}>

                  {/* Avatar/Icon */}
                  <Avatar
                    className="notification-avatar"
                    sx={{ bgcolor: "#3D0808", width: 36, height: 36, mr: 2 }}>

                    <NotificationsActiveIcon fontSize="small" />
                  </Avatar>

                  {/* Notification Content */}
                  <ListItemText
                    primary={
                      <Typography
                        className="notification-heading"
                        variant="subtitle1"
                        sx={{ fontWeight: 600, color: "#3D0808" }}>
                        {notification.Heading}
                      </Typography>
                    }
                    secondary={
                      <Typography  
                        className="notification-message"  
                        variant="body2"  
                        sx={{ color: "#555", mt: 0.5, whiteSpace: "pre-line" }}  
                        dangerouslySetInnerHTML={{ __html: notification.Message }}  
                      />
                    }
                  />
                </ListItem>
              ))}
          </List>
        ) : (
          <Typography
            className="notification-empty"
            variant="body2"
            sx={{
              color: "#777",
              textAlign: "center",
              mt: 3,
              fontStyle: "italic",
            }}
          >
            No notifications available.
          </Typography>
        )}
      </Box>
    </Box>
  );
};


export default NotificationPanel;
